import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb } from '../../shared/components/breadcrumb/Breadcrumb';
import { Page } from '../../layout';
import { OrganizationList } from './shared/components/OrganizationList';
import ApolloError from '../../shared/components/ApolloError';
import { useOrganizationSearch } from '../hooks/useOrganizationSearch';

const LEGAL_DOCUMENTS_URL = '/legal-documents';
const PAGE_TITLE = 'Organization Search';

const LegalDocumentsOrganizationSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPageURL = location.pathname;

  const breadcrumbPathItems = [
    { name: 'Legal Documents', url: currentPageURL },
    { name: 'Organization Search', url: '' }
  ];

  const { organizations, totalCount, loading, error, searchState } = useOrganizationSearch();

  const handleSelectOrganization = orgId => {
    navigate(`${LEGAL_DOCUMENTS_URL}/${orgId}`);
  };

  if (error) {
    return <ApolloError />;
  }

  return (
    <Page title={PAGE_TITLE}>
      <Breadcrumb pathItems={breadcrumbPathItems} />
      <OrganizationList
        shouldShowSearchControls={true}
        onSelectOrganization={handleSelectOrganization}
        organizations={organizations}
        totalCount={totalCount}
        loading={loading}
        searchTextPlaceholder='Search by Name'
        searchState={searchState}
      />
    </Page>
  );
};

export default LegalDocumentsOrganizationSearch;
